import { Component, Input } from "@angular/core";

@Component({
  template: `
    <ng-container>
      <ion-grid class="ion-margin-top full-width">
        <ion-row class="transparent-background full-width" [ngClass]="{ 'padding-bottom': withLogo }">
          <cdn-img size="lg" class="mountain-image full-width" src="/assets/img/mountains-separator.svg"></cdn-img>
        </ion-row>

        @if (withLogo) {
          <ion-row>
            <ion-col push="3" size="6" [ngStyle]="{ 'margin-top': extraMarginAboveLogo }" class="full-width">
              <cdn-img
                size="md"
                class="ion-margin-vertical full-width logo"
                src="/assets/logo/light_logo_horizontal.png"></cdn-img>
            </ion-col>
          </ion-row>
        }
      </ion-grid>
    </ng-container>
  `,
  selector: "rc-footer-mountains",
  styleUrls: ["./footer-mountains.component.scss"],
  standalone: false,
})
export class FooterMountainsComponent {
  @Input() public extraMarginAboveLogo = "0";
  @Input() public withLogo: boolean;

  constructor() {}
}
